<template>
    <span>
        <LoadingStruct is-dark :is-loading="loading">
            <Galleries v-if="getMode === 'gallery'" />
            <TransferChannel v-else-if="getMode === 'swifter'" />
            <ClickAndBuys v-else-if="getMode === 'clickandbuy'" />
            <!-- the flags come with /infos: a view mounted before would be
                 swapped out with its intervals and request token still live -->
            <template v-else-if="$store.state.infosLoaded">
                <MainTerminal v-if="isTerminalStudio" />
                <Main v-else-if="isUploadStudio" />
                <MainLegacy v-else />
            </template>

            <ErrorMessage :error="error" />
        </LoadingStruct>
    </span>
</template>

<script>
import Main from '@/views/Main.vue';
import MainLegacy from '@/views/MainLegacy.vue';
import MainTerminal from '@/views/MainTerminal.vue';
import axios from 'axios';
import Galleries from '@/views/Galleries.vue';
import LoadingStruct from '@/views/LoadingStruct.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import ClickAndBuys from '@/views/clickandbuy/ClickAndBuys.vue';
import TransferChannel from '@/views/TransferChannel.vue';

export default {
    name: 'Start',
    components: {
        TransferChannel,
        ClickAndBuys,
        ErrorMessage,
        LoadingStruct,
        Galleries,
        Main,
        MainLegacy,
        MainTerminal,
    },
    data() {
        return {
            loading: true,
            mode: 'upload',
            error: null,
        };
    },
    created() {
        this.getNode();
    },
    methods: {
        getNode() {
            let http = axios.create();
            http.get(this.apiUrl + '/mode')
                .then((response) => {
                    this.$store.state.mode = response.data.mode;
                    this.error = null;
                    this.loading = false;
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.error = e;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped></style>
